import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appBarHeight } from "@/components/@common/AppBar/AppBar";
import { HomeSwitch } from "@/components/@common/AppBar/HomeSwitch";
import AnnualPassCard, { SPLIT_STRING } from "@/components/Package/AnnualCard";
import AnnualPassSwiper from "@/components/Package/AnnualPassSwiper";
import { PassList } from "@/components/Package/PassList";
import Notice from "@/components/Package/SubscribeToPass/SubscribeNotice";
import { usePassTab } from "@/components/Package/hooks/usePassTab";
import UpsellingSection from "@/components/PassUpgrade/UpsellingSection";
import { LoginDialogWithStore } from "@/components/modal/LoginDialogWithStore";
import PassConfirmDialog from "@/components/passes/dialogs/PassConfirmDialog";
import PassNoticeDialog from "@/components/passes/dialogs/PassNoticeDialog";
import { REDIRECT_QUERY } from "@/hooks/useRedirect";
import useSearchParams from "@/hooks/useSearchParams";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { CASH_INDEX_PAGE } from "@/settings/constant";
import { Button, Divider, Typography as SdsTypography, TabContent, Tabs, Typography } from "@bookips/sds";
import { AnimatePresence, motion } from "framer-motion";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { Subjects } from "src/api/product";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
import usePassStore from "src/store/pass";
import { GRADE_LABEL } from "../../api/membership";
const passNoticeList = [
    "이용권 상품의 이용 기한, 이용 범위, 이용 방법 등은 이용권마다 상이할 수 있습니다. 이용권 상품을 클릭하고 <이용권 상세정보>를 확인해주세요.",
    "이용권 상품의 환불은 쏠북 서비스 페이지 우측 하단 고객 센터 문의 버튼 혹은 메인 페이지 하단의 채널톡 문의를 통해 접수할 수 있습니다. ",
    "환불 정책은 이용권 상품별로 상이하오니 이용권 상품을 클릭하고 <이용권 상세정보>를 확인하거나, 서비스 약관 내 환불 정책을 확인해주세요."
];
const TEACHER_TABS = [
    {
        label: "영어",
        value: "EN"
    },
    {
        label: "국어",
        value: "KO"
    },
    {
        label: "수학",
        value: "MA"
    },
    {
        label: "과학",
        value: "SC"
    },
    {
        label: "사회",
        value: "SO"
    },
    {
        label: "전과목",
        value: "ALL"
    }
];
const STUDENT_TABS = [
    {
        label: "고1",
        value: "GRADE1"
    },
    {
        label: "고2∙3",
        value: "GRADE23"
    }
];
const MembershipPage = (param)=>{
    let { pageType: initialPageType  } = param;
    var _groupBySubjectData_products;
    const router = useRouter();
    const { push , query  } = router;
    const { user , isLoggedIn  } = useAuthStore();
    const { isMobile  } = useWindowDimensions();
    const searchParam = useSearchParams();
    const [confirmDialogType, setConfirmDialogType] = useState(null);
    const [noticeInfo, setNoticeInfo] = useState(null);
    // 선생님/학생 토글 상태 - URL의 pageType으로 초기화
    const { homeType , setHomeType  } = useHomeSwitchStore();
    // URL에서 가져온 pageType으로 store 동기화
    useEffect(()=>{
        if (initialPageType && initialPageType !== homeType) {
            setHomeType(initialPageType);
        }
    }, [
        initialPageType
    ]);
    // 토글 변경 시 URL 동기화 (shallow 제거: initialPageType 갱신을 위해 SSR 재실행 필요)
    const handleHomeTypeChange = useCallback((newType)=>{
        setHomeType(newType);
        // 타입 변경 시 쿼리 파라미터 초기화
        router.push("/passes/".concat(newType));
    }, [
        setHomeType,
        router
    ]);
    const { groupBySubjectData , handlePassTab , handleStudentGradeTab , studentGrade , passCategory , isPassProductsSuccess , mainGroups , isAnnualPassProductsSuccess  } = usePassTab({
        pageType: initialPageType
    });
    const isTeacher = initialPageType === "teacher";
    // mx-207 'Tab Name' — 학생 학년 탭만 보낸다. 선생님 탭(과목)은 Subject 프로퍼티가 이미 담고 있다
    const mainTabName = isTeacher ? undefined : GRADE_LABEL[studentGrade];
    const [teacherTab, setTeacherTab] = useState((passCategory === null || passCategory === void 0 ? void 0 : passCategory.toString()) || Subjects.EN);
    const { setRedirectPath  } = usePassStore((state)=>({
            setRedirectPath: state.setRedirectPath
        }));
    const handleSubscribeWarningDialog = ()=>{
        setConfirmDialogType("alreadySubscribed");
    };
    const handleClickTab = (value)=>{
        if (isTeacher) {
            setTeacherTab(value);
            handlePassTab(value);
        } else {
            handleStudentGradeTab(value);
        }
    };
    // 준비중 다이얼로그가 닫히면 기본 탭으로 되돌린다.
    // - 선생님: 기본 과목(영어) / - 학생: 기본 학년(GRADE1)
    const handleConfirmDialogClose = ()=>{
        if (confirmDialogType === "preparing") {
            handleClickTab(isTeacher ? Subjects.EN : "GRADE1");
        }
        setConfirmDialogType(null);
    };
    // 연간권 카드의 '유의사항 보기' 클릭 시 subInfo(위) + noticeInfo(아래)를 합쳐 다이얼로그에 표시한다.
    // subInfo 항목은 '$' 구분자를 공백으로 이어 한 줄로 표시하고, noticeInfo와는 빈 줄로 분리한다. (PassNoticeDialog는 whitespace-pre-line)
    const handleNoticeOpen = (param)=>{
        let { subInfo , noticeInfo  } = param;
        const subText = subInfo ? subInfo.split(SPLIT_STRING).join(" ") : "";
        setNoticeInfo([
            subText,
            noticeInfo
        ].filter(Boolean).join("\n\n"));
    };
    const handleCashChargeClick = ()=>{
        mixpanelEvent("Cash Sales Button Clicked", {
            position: "이용권 구매페이지",
            button_position: "상단_캐시 충전하기"
        });
        push(CASH_INDEX_PAGE);
    };
    // 엑스퍼트에서 넘어온 경우를 위해 redirect 저장을 합니다.
    useEffect(()=>{
        if (searchParam.get(REDIRECT_QUERY)) {
            setRedirectPath(searchParam.get(REDIRECT_QUERY));
        }
    }, [
        searchParam
    ]);
    // URL의 subject 쿼리가 변경될 때 탭 UI 동기화
    useEffect(()=>{
        if (passCategory && isTeacher) {
            const target = passCategory.toString();
            if (target !== teacherTab) {
                setTeacherTab(target);
            }
        }
    }, [
        passCategory
    ]);
    // '현재 탭 기준 결과 없음' 파생 상태. 두 쿼리가 모두 성공한 시점에만 true가 될 수 있어 로딩 중 오발화가 없다.
    // (탭 전환 시 queryKey가 바뀌면 isSuccess가 false로 떨어져 refetch 동안 false 유지)
    // groupBySubjectData는 학생 모드에서 항상 객체(빈 products)라 truthy 체크로는 안 되고 `?.products?.length`로 판정.
    const isEmptyResult = isPassProductsSuccess && isAnnualPassProductsSuccess && !mainGroups.length && !(groupBySubjectData === null || groupBySubjectData === void 0 ? void 0 : (_groupBySubjectData_products = groupBySubjectData.products) === null || _groupBySubjectData_products === void 0 ? void 0 : _groupBySubjectData_products.length);
    // 메인 상품 구획·이용권 리스트가 모두 없다면 준비중 다이얼로그를 띄웁니다.
    // deps가 primitive boolean 하나라 effect가 '비어있지 않음 → 비어있음' 전이(및 빈 상태 최초 마운트)에서만 실행됨
    // — 같은 빈 탭에서의 리렌더로는 재발화하지 않고, 닫기로 기본 탭 복귀 후 다시 빈 탭에 진입하면 재전이로 다시 발화한다.
    useEffect(()=>{
        if (isEmptyResult) {
            setConfirmDialogType("preparing");
        }
    }, [
        isEmptyResult
    ]);
    // 1.17.0 이용권 페이지 진입시, 유저 타입에 따라 초기 탭 상태값이 달라진다.
    // 유저 타입이 학생이나 학부모라면, 초기 탭 상태값은 전과목으로 설정한다.
    // 유저 타입이 선생님이나 원장이라면, 초기 탭 상태값은 유저의 주 과목으로 설정한다.
    // 단, 학생 페이지에서는 전과목 탭만 있으므로 이 로직을 스킵한다.
    useEffect(()=>{
        if (!isLoggedIn) return;
        if (query.subject) return;
        if (!isTeacher) return; // 학생 페이지에서는 스킵
        if (user.job === "parent" || user.job === "student") {
            handleClickTab("ALL");
        }
        if (user.job === "teacher" || user.job === "principal" || user.job === "etc" || user.job === "university") {
            handleClickTab(user.mainSubject || Subjects.EN);
        }
    }, [
        isLoggedIn,
        user,
        query,
        isTeacher
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-10 h-full min-h-[calc(100vh-75px)] w-full max-sm:gap-10",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mx-auto flex w-full max-w-[840px] flex-col gap-12 max-md:px-8 max-sm:h-full max-sm:gap-10 max-sm:px-5",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "relative flex flex-col gap-5",
                    children: [
                        /*#__PURE__*/ _jsx(SdsTypography, {
                            variant: "h4",
                            children: "이용권 구매"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-start justify-between gap-2.5 max-sm:items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Tabs, {
                                    size: "lg",
                                    value: isTeacher ? teacherTab : studentGrade,
                                    tabs: isTeacher ? TEACHER_TABS : STUDENT_TABS,
                                    onValueChange: handleClickTab,
                                    // 학생 탭은 2개라 스크롤이 없어 그라데이션 오탐만 발생 → 실제 오버플로되는 선생님 탭에서만 사용
                                    scrollGradient: isTeacher,
                                    classes: {
                                        list: "[&_.bg-gray-100]:hidden"
                                    },
                                    children: (isTeacher ? TEACHER_TABS : STUDENT_TABS).map((tab)=>/*#__PURE__*/ _jsx(TabContent, {
                                            value: tab.value,
                                            className: "hidden"
                                        }, tab.value))
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    "data-button": "cash-charge",
                                    // className="absolute top-15 right-0"
                                    onClick: handleCashChargeClick,
                                    color: "primary",
                                    size: "md",
                                    children: "캐시 충전하기"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex min-h-screen w-full flex-col gap-12 border-t border-gray-100 py-10 max-lg:py-12 max-sm:gap-10 max-sm:py-10",
                children: [
                    /*#__PURE__*/ _jsx(UpsellingSection, {
                        isLoggedIn: isLoggedIn
                    }),
                    mainGroups.map((row)=>/*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mx-auto flex w-full max-w-[840px] flex-col gap-12 max-md:px-8 max-sm:h-full max-sm:gap-10 max-sm:px-5",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-6 flex flex-col gap-1",
                                        children: [
                                            row.title && /*#__PURE__*/ _jsx(Typography, {
                                                variant: "h5",
                                                className: "max-sm:typo-h6",
                                                children: row.title
                                            }),
                                            row.subTitle && /*#__PURE__*/ _jsx(Typography, {
                                                variant: "body1",
                                                className: "text-primary max-sm:typo-body2",
                                                children: row.subTitle
                                            })
                                        ]
                                    })
                                }),
                                isMobile ? /*#__PURE__*/ _jsx(AnnualPassSwiper, {
                                    passItems: row.items,
                                    handleClick: handleNoticeOpen,
                                    tabName: mainTabName
                                }) : /*#__PURE__*/ _jsx("div", {
                                    className: "mx-auto flex w-full max-w-[840px] flex-col gap-12 max-md:px-8 max-sm:h-full max-sm:gap-10 max-sm:px-5",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mx-auto flex w-full max-w-[840px] flex-wrap gap-3",
                                        children: row.items.map((pass)=>/*#__PURE__*/ _jsx(AnnualPassCard, {
                                                ...pass,
                                                handleClick: handleNoticeOpen,
                                                tabName: mainTabName
                                            }, pass.id))
                                    })
                                })
                            ]
                        }, row.key)),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mx-auto flex w-full max-w-[840px] flex-col gap-12 max-md:px-8 max-sm:h-full max-sm:gap-10 max-sm:px-5",
                        children: [
                            /*#__PURE__*/ _jsx(Divider, {}),
                            groupBySubjectData && /*#__PURE__*/ _jsx(PassList, {
                                data: groupBySubjectData,
                                handleSubscribeWarningDialog: handleSubscribeWarningDialog
                            }),
                            /*#__PURE__*/ _jsx(Notice, {
                                title: "유의사항",
                                caution: passNoticeList,
                                className: "max-h-none"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LoginDialogWithStore, {}),
            /*#__PURE__*/ _jsx(PassConfirmDialog, {
                type: confirmDialogType,
                onClose: handleConfirmDialogClose
            }),
            noticeInfo !== null && /*#__PURE__*/ _jsx(PassNoticeDialog, {
                isOpen: true,
                info: noticeInfo,
                onClose: ()=>setNoticeInfo(null)
            }),
            /*#__PURE__*/ _jsx(AnimatePresence, {
                children: /*#__PURE__*/ _jsx(motion.div, {
                    initial: {
                        opacity: 0,
                        y: 20
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    exit: {
                        opacity: 0,
                        y: 20
                    },
                    transition: {
                        duration: 0.2,
                        ease: "easeInOut"
                    },
                    style: {
                        bottom: appBarHeight + 20
                    },
                    className: cn("fixed left-1/2 z-50 -translate-x-1/2", "lg:hidden"),
                    children: /*#__PURE__*/ _jsx(HomeSwitch, {
                        value: homeType,
                        onChange: handleHomeTypeChange
                    })
                })
            })
        ]
    });
};
export var __N_SSP = true;
export default MembershipPage;
